import { BiInfoCircle } from 'react-icons/bi';
import classes from './InfoCircle.module.css';
import Tooltip from '@mui/material/Tooltip';

interface Props {
    tooltip: string,
    position: any
};

const InfoCircle = ({ tooltip, position }: Props) => {
    return (
        <Tooltip title={tooltip} placement={position}>
            <div>
                <BiInfoCircle
                    className={classes.infoCircle}
                />
            </div>
        </Tooltip>

    )
};

export default InfoCircle;